
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CheckboxComponent extends Vue {
  @Prop({ default: false }) checked!: boolean;
  @Prop({ default: false }) disabled!: boolean;
}
